__turbopack_context__.v({
  "accordionContent": "Accordion-module__cMz9MW__accordionContent",
  "accordionIndicator": "Accordion-module__cMz9MW__accordionIndicator",
  "accordionItem": "Accordion-module__cMz9MW__accordionItem",
  "accordionRoot": "Accordion-module__cMz9MW__accordionRoot",
  "accordionTrigger": "Accordion-module__cMz9MW__accordionTrigger",
  "readMoreButton": "Accordion-module__cMz9MW__readMoreButton",
});
